import { CommonUtility } from '@utility/common';
import { DateFormat, DateUtility } from '@utility/date';
import moment from 'moment';

export const parseChartValue = value => {
  const checkWith = Number.isNaN(value) ? 0 : value || 0;
  return +parseFloat(`${checkWith}`).toFixed(2);
};

export const chartDisplayDate = date =>
  DateUtility.formatDate(date, DateFormat.date);

export const parseDate = date =>
  DateUtility.formatDate(date, DateFormat.yearMonthDate);

export const parseDates = data =>
  // @ts-expect-error - TS18046: 'd' is of type 'unknown'.
  CommonUtility.isValidArray(data) ? data.map(d => parseDate(d.from)) : [];

export const getDatesBetween = (startDate, endDate) => {
  const dates = [];
  while (moment(startDate) <= moment(endDate)) {
    // @ts-expect-error - TS2345: Argument of type 'any' is not assignable to parameter of type 'never'.
    dates.push(startDate);
    startDate = moment(startDate)
      .add(1, 'days')
      .format(DateFormat.yearMonthDate);
  }
  return dates;
};

export const getMarketData = (predictions, regionId) => {
  let marketData = [];

  if (CommonUtility.isValidArray(predictions?.[regionId])) {
    // @ts-expect-error - TS2322: Type 'unknown[]' is not assignable to type 'never[]'.
    marketData = predictions[regionId];
  } else if (CommonUtility.isValidArray(predictions)) {
    predictions.forEach(d => {
      if (CommonUtility.isValidArray(d?.[regionId])) {
        // @ts-expect-error - TS2322: Type 'unknown[]' is not assignable to type 'never[]'.
        marketData = d[regionId];
      }
    });
  }

  return marketData;
};
